import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

// eslint-disable-next-line import/no-unresolved
import ReviewPageBanner from "@regional/templates/Application/reviewPageBanner";

import { ReviewPropsProvider } from "../context/reviewItemContext";
import Layout from "../Layouts/Layout";
import TabPanel from "./TabPanel";
import FormAlert from "../Field/FormAlert";
import PaymentTable from "../../../features/application/components/PaymentTable";
import { recordPaymentMethods } from "../../../services/global.constant";

function FormReview(props) {
  const {
    value,
    tabItems,
    applicationType,
    handleSubmit,
    validateAndSubmit,
    handleError,
    applicationStatus,
    currentData,
    handleTabChange,
    formTemplate,
    printApplicationBtn,
  } = props;

  const warningMsg = <ReviewPageBanner applicationType={applicationType} />;

  const memoReviewLayout = useMemo(
    () => (
      <Layout
        components={tabItems}
        handleTabChange={handleTabChange}
        formTemplate={formTemplate}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <TabPanel value={value} index={tabItems.length} customMargin>
      <ReviewPropsProvider>
        <FormAlert severity="warning" message={warningMsg} marginBtm="1rem" />
        {printApplicationBtn}
        {memoReviewLayout}
        <PaymentTable />
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          className="reviewTabBtnContainer"
        >
          <Grid item>
            <Button variant="contained" component={Link} to="/applications">
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={handleSubmit(validateAndSubmit, handleError)}
              startIcon={<CheckCircleRoundedIcon />}
            >
              {applicationStatus === "Open" &&
                currentData.paymentMethod &&
                recordPaymentMethods.includes(currentData.paymentMethod) &&
                "Pay & "}
              Submit
            </Button>
          </Grid>
        </Grid>
      </ReviewPropsProvider>
    </TabPanel>
  );
}

export default FormReview;
FormReview.propTypes = {
  value: PropTypes.number.isRequired,
  tabItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  validateAndSubmit: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  applicationStatus: PropTypes.string,
  currentData: PropTypes.shape({
    paymentMethod: PropTypes.string,
  }).isRequired,
  applicationType: PropTypes.string,
  formTemplate: PropTypes.shape({}),
  handleTabChange: PropTypes.func,
};

FormReview.defaultProps = {
  applicationType: "",
  applicationStatus: "",
  formTemplate: {},
  handleTabChange: () => {},
};
